/*
 * API Config
 */


class API {
  //DOMAIN
  //https://admin.shizzniz.com/service/public/api/v1/
  //DOMAIN = 'http://localhost:80';
  //DOMAIN = 'http://cryodex:8888';  
  DOMAIN = 'https://shizzniz.com';//correct for server online
  
  BASE = '/api/v1'; //correct for local host
  
  //DOMAIN = 'http://127.0.0.1:8000'; // this is correct for local
  
  API_URL_PATH = 'https://admin.shizzniz.com/service/public/api/v1';//this.DOMAIN + this.BASE;
  
  //BASE = '/api/v1'; //this is correct for local

  FIRE_BASE_SENDER_ID = '953281282605';

  LIMIT = 'results?limit=3';

  // Login
  LOGIN = '/login';
  REGISTER = '/register';
  GET_ALL_CITIES = "/city";
  GET_ALL_COUNTRIES = "/country";
  GET_USER_INFORMATION ="/cryodexes/";
  GET_SELECTED_CRYODEX = "/cryodexes/"
  
  CRYODEX_GROUP_MEMBER_DELETE ="/cryodexgroups/";
  INFODEX_GROUP_MEMBER_DELETE ="/infodexGroupMembers";
  CRYODEX_GROUP ="/cryodexgroups/";
  CRYODEX_GROUP_RENAME ="/cryodexgroups/rename/";
  INFODEX_GROUP ="/infodexgroups/";
  INFODEX_GROUP_RENAME ="/infodexgroups/rename/";
  
  CRYODEX_GROUPS_GET ="/cryodexgroups/";
  CRYODEX_GROUPS_POST ="/cryodexgroups";
  
  INFODEX_ALL_GET ="/infodex/";
  INFODEX_GET ="/infodex/";
  //INFODEX_LINKED_GET ="/cryodex/infodex/link/";
  INFODEX_LINKED_INFO_GET ="/infodexlinks/";
  INFODEX_LINKED_PUT ="/infodexlinks/";
  INFODEX_LINKED_POST ="/infodexlinks";
  CRYODEX_ALL_GET ="/cryodex/associations/";
  
  CRYODEX_LINKS_GET ="/cryodexes";
  CRYODEX_FEEDS_GET ="/cryodex/feeds";
  CRYODEX_INFODEX_LINK_POST ="/cryodexes";
  
  INFODEX_GROUPS_GET ="/infodexgroups/";
  INFODEX_GROUPS_POST ="/infodexgroups";
  CRYODEX_MAP_RELATIONSHIP_POST ="/cryodexgroupsmembers";
  INFODEX_MAP_RELATIONSHIP_POST ="/infodexgroupsmembers";

  CRYODEX_INVITE_GET = '/cryodexes/invite/'; // cryodexes/invite/{from}/{to}/{status} [status: pending,accepted,reject,cancel]
  CRYODEX_LOCATION_GET = '/cryodexes/location/'; // cryodexes/location/{cryodex_id}/{longitude}/{latitude}/

  MAILBOX_GET = '/mailbox/'
  MAILBOX_UPDATE_INVITE = '/mailbox/update'
  CRYODEX_PASSWORD_RESET_POST = '/password/reset'
  
  NOTIFICATION = '/notification'
  SETTINGS_GET = '/settings/'
  SETTINGS_SAVE = '/settings/save';
  
  //_
  
  GET_FRIENDS = "/friends/getfriends";
  
  GET_ALL_FRIENDS = "/allFriends/getAllFriends";
  
  UPDATE_CRYODEX = "/update";
  
  GET_FS = "/friends/getFs";
  
  GET_F = "/friends/getF";
  
  GET_PLACES = "/friends/getPlaces";
  
  GET_ALL_FRIENDS_GOING_TO_MY_LOCATION = "/cryodex/getrealfriends";
}

export default API;
